/** @format */

import Axios from "axios";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { Checkbox } from "@mui/material";
import UpdateIcon from "@mui/icons-material/SystemUpdateAlt";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const TOOL_NAMES = [
  "", "Global Database", "Valuation", "Financial Insights", "Pitchdeck",
  "Partnership", "Virtual Events", "Market Insights", "Recruitment",
  "Network", "Settings", "Feed", "Chats", "Notifications",
  "Pricing", "Blogs", "Others",
];

const labelStyle = {
  fontFamily: "Nunito", fontSize: 11, fontWeight: 800, color: "#6b7280",
  textTransform: "uppercase", letterSpacing: 0.7, marginBottom: 6, display: "block",
};
const inputStyle = {
  width: "100%", boxSizing: "border-box", fontFamily: "Nunito", fontSize: 14,
  color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8,
  padding: "10px 14px", outline: "none", background: "#fff",
};

export default function Platformupdates() {
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [expireIn7days, setexpireIn7days] = useState(false);
  const [toolname, settoolname] = useState("");
  const [updateDate, setupdateDate] = useState(new Date());
  const [platformupdates, setplatformupdates] = useState([]);

  const getPlatformUpdates = async () => {
    try {
      const response = await axios.get("/api/adminlatest/platformupdates");
      if (response.data.success) setplatformupdates(response.data.data);
    } catch (error) { console.log(error); }
  };

  useEffect(() => { getPlatformUpdates(); }, []);

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    if (!toolname) return toast.warning("Select a tool");
    if (!confirm("Are you sure you want to publish this platform update?")) return;
    await Axios.post("/api/adminlatest/platformupdate", { toolname, subject, description, updateDate, expireIn7days })
      .then((res) => {
        if (res.data.success) {
          getPlatformUpdates();
          toast.success("Published successfully");
          setSubject(""); settoolname(""); setDescription(""); setexpireIn7days(false);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleDeleteUpdate = async (id) => {
    if (!confirm("Delete this update?")) return;
    try {
      const response = await axios.get(`/api/adminlatest/deleteplatformupdate/${id}`);
      if (response.data.success) { toast.success("Deleted"); getPlatformUpdates(); }
    } catch (error) { console.log(error); }
  };

  return (
    <div style={{ padding: "36px 40px", boxSizing: "border-box" }}>
      <ToastContainer />

      {/* Page header */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 28 }}>
        <div style={{ background: "#111827", borderRadius: 10, width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <UpdateIcon style={{ color: "#fff", fontSize: 20 }} />
        </div>
        <div>
          <h1 style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 26, color: "#111827", margin: 0 }}>
            Platform Updates
          </h1>
          <p style={{ fontFamily: "Nunito", fontSize: 13, color: "#6b7280", margin: 0 }}>
            Publish feature announcements and changelogs to users
          </p>
        </div>
      </div>

      {/* Two-column layout */}
      <div style={{ display: "grid", gridTemplateColumns: "420px 1fr", gap: 24, alignItems: "start" }}>

        {/* ── Left: Publish form (sticky) ── */}
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, padding: "24px 28px", position: "sticky", top: 24 }}>
          <p style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 13, color: "#374151", margin: "0 0 20px", textTransform: "uppercase", letterSpacing: 1 }}>
            New Update
          </p>
          <form onSubmit={handleOnSubmit}>

            {/* Tool */}
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Tool</label>
              <select
                value={toolname}
                onChange={(e) => settoolname(e.target.value)}
                required
                style={{ ...inputStyle, height: 40, padding: "0 14px", cursor: "pointer" }}
              >
                <option value="">Select tool…</option>
                {TOOL_NAMES.slice(1).map((name, i) => (
                  <option key={i + 1} value={i + 1}>{name}</option>
                ))}
              </select>
            </div>

            {/* Subject */}
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Subject</label>
              <input
                type="text"
                placeholder="What's new?"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
                style={inputStyle}
              />
            </div>

            {/* Description */}
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Description</label>
              <textarea
                rows={4}
                placeholder="Describe the update in detail…"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
                style={{ ...inputStyle, resize: "vertical", lineHeight: 1.6 }}
              />
            </div>

            {/* Update Date */}
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Update Date</label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={updateDate}
                  onChange={(v) => setupdateDate(v)}
                  format="dd MMM yyyy"
                  sx={{ width: "100%" }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: {
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          fontFamily: "Nunito", fontSize: 14, borderRadius: "8px",
                          "& fieldset": { borderColor: "#e5e7eb" },
                          "&:hover fieldset": { borderColor: "#9ca3af" },
                        },
                      },
                    },
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>

            {/* Expire checkbox */}
            <div style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 24, padding: "12px 14px", background: "#f9fafb", borderRadius: 8, border: "1px solid #e5e7eb" }}>
              <Checkbox
                checked={expireIn7days}
                onChange={(e) => setexpireIn7days(e.target.checked)}
                size="small"
                sx={{ padding: 0, color: "#9ca3af", "&.Mui-checked": { color: "#111827" } }}
              />
              <p style={{ fontFamily: "Nunito", fontSize: 13, color: "#374151", margin: 0, lineHeight: 1.5 }}>
                Auto-hide after <strong>7 days</strong> from the update date
              </p>
            </div>

            <button
              type="submit"
              style={{ width: "100%", fontFamily: "Nunito", fontSize: 14, fontWeight: 700, background: "#111827", color: "#fff", border: "none", borderRadius: 8, padding: "12px", cursor: "pointer" }}
            >
              Publish Update
            </button>
          </form>
        </div>

        {/* ── Right: Live updates list ── */}
        <div>
          <p style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 13, color: "#374151", margin: "0 0 16px", textTransform: "uppercase", letterSpacing: 1 }}>
            Live Updates ({platformupdates.length})
          </p>

          {platformupdates.length === 0 ? (
            <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "40px 24px", textAlign: "center" }}>
              <p style={{ fontFamily: "Nunito", fontSize: 14, color: "#9ca3af", margin: 0 }}>No active updates published</p>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {platformupdates.map((v, i) => (
                <div key={i} style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "18px 20px" }}>
                  <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      {/* Tool badge + date */}
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                        <span style={{ fontFamily: "Nunito", fontSize: 11, fontWeight: 700, background: "#f3f4f6", color: "#374151", borderRadius: 20, padding: "3px 10px", whiteSpace: "nowrap" }}>
                          {TOOL_NAMES[v.toolname] || "Unknown"}
                        </span>
                        <span style={{ fontFamily: "Nunito", fontSize: 12, color: "#9ca3af" }}>
                          {new Date(v.updateDate).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
                        </span>
                        {v.expireIn7days && (
                          <span style={{ fontFamily: "Nunito", fontSize: 11, fontWeight: 700, background: "#fef3c7", color: "#92400e", borderRadius: 20, padding: "3px 10px" }}>
                            7-day expiry
                          </span>
                        )}
                      </div>
                      {/* Subject */}
                      <p style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 15, color: "#111827", margin: "0 0 4px" }}>
                        {v.subject}
                      </p>
                      {/* Description */}
                      <p style={{ fontFamily: "Nunito", fontSize: 13, color: "#6b7280", margin: 0, lineHeight: 1.6 }}>
                        {v.description}
                      </p>
                    </div>
                    {/* Delete */}
                    <button
                      onClick={() => handleDeleteUpdate(v._id)}
                      style={{ flexShrink: 0, fontFamily: "Nunito", fontSize: 12, fontWeight: 700, background: "#fff", color: "#dc2626", border: "1px solid #dc2626", borderRadius: 8, padding: "7px 12px", cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}
                    >
                      <DeleteOutlineIcon style={{ fontSize: 15 }} />
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
